import type { FC } from "react";

import { t } from "i18n/i18n";
import { SquareButton } from "mds/components/buttons/SquareButton";
import { VerifiedIcon } from "mds/icons";

type OfficialSubmissionFooterProps = {
  isOfficial: boolean;
  isDisabled?: boolean;
  onSetAsOfficial: () => void;
};

export const OfficialSubmissionFooter: FC<OfficialSubmissionFooterProps> = ({
  isOfficial,
  isDisabled,
  onSetAsOfficial,
}) => {
  return (
    <div className="relative z-20 -mx-4 flex shrink-0 flex-col gap-3 rounded-b-lg bg-white px-4 pt-3">
      <div
        className="pointer-events-none absolute inset-x-0 bottom-full h-[15px] bg-gradient-to-t from-black/[0.06] to-transparent"
        aria-hidden
      />
      {isOfficial ? (
        <SquareButton
          as="div"
          className="pointer-events-none w-fit cursor-default"
          kind="complete"
          size="s"
        >
          <VerifiedIcon className="text-green" />
          {t("assessment_card.official_submission")}
        </SquareButton>
      ) : (
        <SquareButton
          disabled={isDisabled}
          kind="tertiary"
          size="s"
          type="button"
          onClick={onSetAsOfficial}
        >
          <VerifiedIcon className="text-green" />
          {t("assessment_card.set_as_official_submission")}
        </SquareButton>
      )}
      <p className="body-s text-black-tint-55">
        {isOfficial
          ? t("assessment_card.official_submission_explanation_official")
          : t("assessment_card.official_submission_explanation_non_official")}
      </p>
    </div>
  );
};
